import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css } from 'aphrodite';

import sharedStyles from 'components/manage_brands/brand_verify/sharedStyles';

function FieldLabel({ label, hint, warning, className }) {
  return (
    <div className={classNames(css(sharedStyles.fieldLabel), className)}>
      {label}
      {hint && <span className={css(sharedStyles.fieldLabelHint)}> ({hint})</span>}
      {warning && <span className={css(sharedStyles.fieldLabelWarning)}> ({warning})</span>}
    </div>
  );
}

FieldLabel.propTypes = {
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  warning: PropTypes.string,
  className: PropTypes.string,
};

export default FieldLabel;
